export default {"src":"/_next/static/media/ctxc.dc017a00.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};